import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {getContract} from "../../../../api/asset/AssetContractService";
import {AssetContractInfo} from "./subPages/AssetContractInfo";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";
import {CommonHistoryList} from "../../../settings/history/subPages/CommonHistoryList";
import {useDispatch, useSelector} from "react-redux";
import {skeleton} from "../../../../redux/slice/apiSlice";

function AssetContractTab(){
    const { id } = useParams();
    const status = useSelector(state => state.api.status);
    const [tab, setTab] = useState([
        {clicked: true, name: "기본정보"},
        {clicked: false, name: "이력관리"},
    ]);

    const [contract, setContract] = useState(null);
    const [assets, setAssets] = useState([]);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    async function getData() {
        dispatch(skeleton(true));

        await getContract(id).then((response) => {
            if(response.status === 201) {
                if (response.data.errorCode = 'AUTHORITY') {
                    alert(response.data.reason)
                    navigate(-1)
                }
            }

            if(response.status===200){
                setContract(response.data);
                setAssets(response.data.assets.map(item => item.assets));
            }else if(response.response.status===401){
                alert("로그인이 필요합니다.")
                navigate("/")
            }else if(response.response.status===403){
                alert("권한이 없습니다.")
                navigate("/")
            }
        });
        dispatch(skeleton(false));
    }

    useEffect(() => {
        if (!id) return;
        setContract(null);
        setAssets([]);
        getData();
    }, [id, status])

    if(contract) {
        return (
                <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
                    <DetailHeroSummaryProvider>
                        <DetailTabBar tabs={tab} setTabs={setTab} />

                    {tab[0].clicked && (
                        <AssetContractInfo
                            key={id}
                            contract={contract}
                            setContract={setContract}
                            assets={assets}
                            setAssets={setAssets}
                        />
                    )}
                    {tab[1].clicked && <CommonHistoryList id={id} tableName={"자산계약관리"} />}
                    </DetailHeroSummaryProvider>
                </div>
        );
    }
}

export {AssetContractTab}